<template>
  <div class="self-center relative p-5">
    <transition
      appear
      mode="out-in"
      :enter-class="['opacity-0', isForward ? 'translate-down' : 'translate-up'].join(' ')"
      :leave-to-class="['opacity-0', isForward ? 'translate-up' : 'translate-down'].join(' ')"
      enter-active-class="transition duration-200 ease-in-out"
      leave-active-class="transition duration-200 ease-in-out"
      @after-enter="lastStepIdx = stepIdx"
    >
      <component
        v-if="langData"
        :is="stepView"
        :class="{'opacity-25': isExpired}"
        @forward="stepIdx++"
        @backward="stepIdx--"
        @step="idx => stepIdx = idx"
      />
    </transition>
    <div
      v-if="isExpired"
      class="absolute left-0 top-0 w-full h-full flex flex-col items-center justify-center"
      style="backdrop-filter: blur(4px);"
    >
      <h1 class="mb-6 text-2xl font-medium uppercase">{{ t('langua.expiration_hint.title') }}</h1>
      <p class="leading-tight">{{ t('langua.expiration_hint.description') }}</p>
      <mc-button type="primary" class="mt-5" @click="reset">{{ t('langua.expiration_hint.button_label') }}</mc-button>
    </div>
  </div>
</template>

<script>
  import {computed, ref} from '@vue/composition-api'

  import McButton from '@/components/mc-button.vue'
  import PinView from '@/views/steps/pin'
  import ConfirmationView from '@/views/steps/confirmation'
  import VerificationView from '@/views/steps/verification'
  import ResultView from '@/views/steps/result'
  import useMelonAuth from '@/composables/melon-auth'
  import useI18n from '@/composables/i18n'

  const stepViews = {
    pin: PinView,
    confirmation: ConfirmationView,
    verification: VerificationView,
    result: ResultView,
  }
  const steps = [...Object.keys(stepViews)]

  export default {
    name: 'StepView',

    components: {
      McButton,
    },

    setup () {
      let {t, langData} = useI18n()

      const stepIdx = ref(process.env.NODE_ENV !== 'development' ? 0 : 0)
      const lastStepIdx = ref(-1)

      const isForward = computed(() => stepIdx.value > lastStepIdx.value)
      const stepView = computed(() => stepViews[steps[stepIdx.value]])

      if (process.env.NODE_ENV === 'development') {
        stepViews.playground = () => import('@/views/steps/playground')
        steps[999] = 'playground'

        let stored = 0
        document.addEventListener('keyup', ({key}) => {
          if (key !== '`') return

          if (stepIdx.value !== 999) {
            stored = stepIdx.value
            stepIdx.value = 999
          } else {
            stepIdx.value = stored === 999 ? 0 : stored
          }
        })
      }

      let {isExpired} = useMelonAuth()

      function reset () {
        stepIdx.value = 0
        isExpired.value = false
      }

      return {
        t,
        langData,

        stepIdx,
        lastStepIdx,
        isForward,
        stepView,

        isExpired,
        reset,
      }
    },
  }
</script>

<style scoped>
  .translate-up {
    transform: translateY(-40px);
  }

  .translate-down {
    transform: translateY(40px);
  }
</style>
